import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import UserStore from '../../stores/common/UserStore';

const base = 'secondary-header';

@inject('HubPerformanceStore')
@observer
class HubPerformanceHeader extends Component {
    render() {
        const { HubPerformanceStore } = this.props;
        const { handleGetPerformanceData, selectedHubCode } = HubPerformanceStore;
        const selectedHubName = UserStore.selectedHub && UserStore.selectedHub.label
            ? UserStore.selectedHub.label
            : selectedHubCode;

        return (
            <div className={`${base} performance__header bg--white`}>
                <div className="performance__header-row row pll prl ptm pbm flex-align-items-center">
                    <div className={`${base}__left performance__header-left col-xs-12 col-md-3 flex-1-only text--left`}>
                        <Link to="/packing">
                            <button className={`${base}__view-all-orders m0`}>
                                Back
                            </button>
                        </Link>
                    </div>
                    <div className="performance__header-title col-xs-12 col-md-6 text--center">
                        <h1 className="m0">Outlet Performance</h1>
                        <p className="m0 text--small">
                            {selectedHubName} • {moment().format('DD/MM/YYYY')}
                        </p>
                    </div>
                    <div className="performance__header-right col-xs-12 col-md-3 text--right">
                        <button
                            className={`${base}__view-all-orders m0`}
                            onClick={() => handleGetPerformanceData()}
                        >
                            Refresh
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default HubPerformanceHeader;
